export default __webpack_public_path__ + "static/media/xMenu.123c1e24.svg";